export const BLOG_METADATA = {
  blog: {
    title: "Everything you need to know about App Revenue Growth - Apphud Blog",
    description:
      "Apphud's App Growth blog is a great source of app monetization best practices, tutorials, use cases, tips and tricks. Subscribe and be up-to-date!",
  },

  case_study: {
    title:
      "Learn more how Apphud clients increase their app revenue - Case Studies",
    description:
      "Discover how Apphud clients boost their app revenue with detailed case studies. Learn effective strategies and insights into subscription app monetization techniques.",
  },

  marketing: {
    title: "Subscription App Marketing Strategies & News | Apphud Blog",
    description:
      "Discover the latest marketing strategies and news for subscription apps on the Apphud Blog. Stay ahead with expert insights, tips, and trends designed to help your app thrive in a competitive market.",
  },

  updates: {
    title: "Apphud Product Updates | Latest Features & Improvements",
    description:
      "Stay informed about the latest features and improvements in Apphud with our regular product updates. Learn how new innovations can help optimize your subscription app growth and performance.",
  },

  development: {
    title: "Subscription App Development News & Insights | Apphud Blog",
    description:
      "Get the latest news and valuable insights on subscription app development from the Apphud Blog. Dive into expert articles, best practices, and resources to enhance your app-building journey.",
  },
};
